import React from "react"
import { StyleSheet, View } from "react-native"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { LinearGradient } from "expo-linear-gradient"

// Garanties de l'abonnement régulier AVEC engagement — le jeu par défaut de la
// carte, réutilisé tel quel par les appels qui ne passent pas de props.
//
// `commitmentOnly` marque celles qui parlent de DURÉE : elles n'énoncent rien
// pour un parent qui ne s'engage pas — « 1er mois sans engagement » suggère même
// que sa liberté s'arrête après un mois, et la pause vacances est un droit de
// l'abonnement engagé. Les garanties de CONTENU (tuteur, formule) valent dans les
// deux cas. Toute garantie ajoutée ici doit se prononcer sur ce drapeau.
export const COMMITMENT_GUARANTEES = [
    {
        icon: "shield-alt",
        label: "1er mois sans engagement",
        subtitle: "Arrêtez à tout moment sans frais et sans conditions",
        commitmentOnly: true,
    },
    {
        icon: "pause-circle",
        label: "Pause vacances sans frais",
        subtitle: "Mettez votre abonnement en pause pendant 3 mois par an",
        commitmentOnly: true,
    },
    {
        icon: "user-check",
        label: "Changer de tuteur quand vous le souhaitez",
        subtitle: "Trouvez le tuteur qui correspond le mieux à votre enfant",
    },
    {
        icon: "sliders-h",
        label: "Changer de formule à tout moment",
        subtitle: "Cours partagés ou individuels, nombre d'heures, matières",
    },
]

// Garanties d'une formule SANS engagement. Dérivée, jamais recopiée : une
// garantie ajoutée à la liste principale atterrit ici automatiquement si elle ne
// porte pas `commitmentOnly`, au lieu d'être oubliée dans un second tableau.
export const NO_COMMITMENT_GUARANTEES = COMMITMENT_GUARANTEES.filter(
    (guarantee) => !guarantee.commitmentOnly
)

/**
 * Carte "Vos garanties" — bloc réassurance partagé. Par défaut, affiche les
 * garanties de l'abonnement régulier engagé (COMMITMENT_GUARANTEES) pour conserver le
 * comportement existant. Passer `items` (array de {icon,label,subtitle}) et/ou
 * `title` pour réutiliser la carte dans un autre contexte (ex. Cours d'été).
 */
export const NewSubscriptionGuaranteesCard = ({
    items = COMMITMENT_GUARANTEES,
    title = "Vos garanties",
}) => {
    return (
        <View style={[styles.card, { overflow: "hidden" }]}>
            <LinearGradient
                colors={[theme.colors.white, theme.colors.linkLighter]}
                style={styles.gradient}
            />
            <TextM fontWeight="bold" fontSize={18} color={theme.colors.black}>
                {title}
            </TextM>
            <View style={{ gap: 15 }}>
                {items.map((guarantee, i) => (
                    <View style={styles.row} key={i}>
                        <View style={styles.iconContainer}>
                            <FontAwesome5
                                name={guarantee.icon}
                                color={theme.colors.primary}
                                size={16}
                            />
                        </View>
                        <View style={{ gap: 5, flex: 1 }}>
                            <TextM fontWeight="Bold" wrap>
                                {guarantee.label}
                            </TextM>
                            <TextM
                                color={theme.colors.light}
                                fontWeight="Medium"
                                wrap
                            >
                                {guarantee.subtitle}
                            </TextM>
                        </View>
                    </View>
                ))}
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    card: {
        backgroundColor: theme.colors.lightMoreTransparent,
        padding: 20,
        borderRadius: 20,
        gap: 15,
    },
    row: {
        flexDirection: "row",
        justifyContent: "space-between",
        gap: 10,
        flexWrap: "wrap",
    },
    iconContainer: {
        width: 40,
        height: 40,
        borderRadius: 10,
        backgroundColor: theme.colors.lightMore,
        justifyContent: "center",
        alignItems: "center",
    },
    gradient: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    },
})
